class RecentlyViewedTracker extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    if (this.productId) {
      this.trackProduct(this.productId);
    }
  }

  trackProduct(id) {
    const limit = 4; // Matches the grid limit in the overlay
    let recentlyViewed = [];
    try {
      const recentlyViewedRaw = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');
      recentlyViewed = recentlyViewedRaw.filter(savedId => !isNaN(savedId) && savedId.toString().trim() !== '');
    } catch (e) {
      recentlyViewed = [];
    }
    
    // Remove if already exists so we can move it to the front
    const index = recentlyViewed.indexOf(id);
    if (index !== -1) {
      recentlyViewed.splice(index, 1);
    }
    
    // Add to beginning
    recentlyViewed.unshift(id);
    
    // Keep only up to the limit
    if (recentlyViewed.length > limit) {
      recentlyViewed = recentlyViewed.slice(0, limit);
    }
    
    localStorage.setItem('recently_viewed_products', JSON.stringify(recentlyViewed));
  }
}

customElements.define('recently-viewed-tracker', RecentlyViewedTracker);
